var userSiteCookieSettings = null;


function homepageSettings() {


    if (parseInt($(window).width()) >= 768) {

        //console.log($(window).width() + " - large" );
        // Big screens - All open
        this.featured = true;
        this.patients = true;
        this.aboutUs = true;
        this.ourPerformance = true;
        this.workingWithUs = true;
        this.yourHealth = true;
        this.getInTouch = true;

    } else {

        //console.log($(window).width() + " - small");
        // Small screens - All closed
        this.featured = false;
        this.patients = false;
        this.aboutUs = false;
        this.ourPerformance = false;
        this.workingWithUs = false;
        this.yourHealth = false;
        this.getInTouch = false;

    }



}



function siteCookie() {
    this.userAccepted = false;
    $('.cookieHolder').css('display', 'none');
}


function getUserCookieAndApply() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;


    userHomepageCookieSettings = $.cookie('NHSHomepage');
    if (userHomepageCookieSettings === undefined) {
        userHomepageCookieSettings = new homepageSettings();
    } else {
        userHomepageCookieSettings = eval( "(" +userHomepageCookieSettings + ")");
    }
    

    // We now have some settings - apply them
    if (userHomepageCookieSettings.featured) {
        quickOpenPanel('hpAccRow_featured');
    }
    if (userHomepageCookieSettings.patients) {
        quickOpenPanel('hpAccRow_patientsandvisitors');
    }
    if (userHomepageCookieSettings.aboutUs) {
        quickOpenPanel('hpAccRow_aboutus');
    }
    if (userHomepageCookieSettings.ourPerformance) {
        quickOpenPanel('hpAccRow_ourperformance');
    }
    if (userHomepageCookieSettings.workingWithUs) {
        quickOpenPanel('hpAccRow_workingwithus');
    }
    if (userHomepageCookieSettings.yourHealth) {
        quickOpenPanel('hpAccRow_yourhealth');
    }
    if (userHomepageCookieSettings.getInTouch) {
        quickOpenPanel('hpAccRow_getintouchgetinvolved');
    }

    return userHomepageCookieSettings;
}

function getSiteCookieSettings() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    userSiteCookieSettings = $.cookie('NHSSiteCookie');
    if (userSiteCookieSettings === undefined) {
        userSiteCookieSettings = new siteCookie();
    } else {
        userSiteCookieSettings = eval("(" + userSiteCookieSettings + ")");
    }

}
function getSiteCookieSettingsBeatson() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    userSiteCookieSettings = $.cookie('NHSBeatsonSiteCookie');
    if (userSiteCookieSettings === undefined) {
        userSiteCookieSettings = new siteCookie();
    } else {
        userSiteCookieSettings = eval("(" + userSiteCookieSettings + ")");
    }

}


function quickOpenPanel( panelClass ) {

    var titlePanel = $('.homepageAccordion .' + panelClass);
    var contentPanel = titlePanel.next();

    // Closed panel - Open it
    titlePanel.addClass('active');
    contentPanel.slideDown();

    // Update open close button
    titlePanel.find('.openCloseHolder').removeClass('openaccord');
    titlePanel.find('.openCloseHolder').addClass('closeaccord');
    titlePanel.find('.openCloseHolder').html('Hide');
}


function setUserCookie() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    $.cookie('NHSHomepage', JSON.stringify( populateUserCookie() ));
    
}

function setSiteCookie() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    var sc = new siteCookie();
    sc.userAccepted = true;
    $.cookie('NHSSiteCookie', JSON.stringify(sc), { path: '/'});

}

function setSiteCookieBeatson() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    var sc = new siteCookie();
    sc.userAccepted = true;
    $.cookie('NHSBeatsonSiteCookie', JSON.stringify(sc), { path: '/' });

}

function populateUserCookie() {
    var accSection = $('.homepageAccordion');
    var cookieSettings = new homepageSettings();

    cookieSettings.featured = accSection.find('.hpAccRow_featured').hasClass('active');
    cookieSettings.patients = accSection.find('.hpAccRow_patientsandvisitors').hasClass('active');
    cookieSettings.aboutUs = accSection.find('.hpAccRow_aboutus').hasClass('active');
    cookieSettings.ourPerformance = accSection.find('.hpAccRow_ourperformance').hasClass('active');
    cookieSettings.workingWithUs = accSection.find('.hpAccRow_workingwithus').hasClass('active');
    cookieSettings.yourHealth = accSection.find('.hpAccRow_yourhealth').hasClass('active');
    cookieSettings.getInTouch = accSection.find('.hpAccRow_getintouchgetinvolved').hasClass('active');
    
    return cookieSettings;

}
/* 
===========================================
Video Cookies 
===========================================
*/

function videoCookie() {
    this.userViewed = false;
}
function getVideoCookieSettings() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    userVideoCookieSettings = $.cookie('NHSVideoCookie');
    if(userVideoCookieSettings === undefined) {
        userVideoCookieSettings = new videoCookie();
    } else {
        userVideoCookieSettings = eval("(" + userVideoCookieSettings + ")");
    }
	
	return userVideoCookieSettings;
}
function setVideoCookie() {

    $.cookie.defaults.expires = 365;
    $.cookie.defaults.json = true;

    var sc = new videoCookie();
    sc.userViewed = true;
    $.cookie('NHSVideoCookie', JSON.stringify(sc));
}







/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));
